export default "__VITE_ASSET__EGjoZFcw__"